var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-screen"},[_c('config-style-injector',{attrs:{"root-selector":`.help-screen`,"config":_vm.config}}),_vm._l((_vm.sections),function(section,index){return _c('help-section',{key:`help-screen-section-${index}`,attrs:{"item-data":section}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }